export const listingsKeys = {
  supplyAnalytics: (listingId: number, workerId?: number | null) =>
    ['listing-supply-analytics', listingId, workerId || 'all'] as const,
}
